import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const SpinnerWrapperStyled = styled.div<{ $height?: string }>`
  position: relative;
  min-height: ${({ $height }): CSSProp => $height || '40rem'};
  width: 100%;
  border-radius: 10px;
  background-color: ${colors.neutral.white};
`;
